module.exports = __webpack_public_path__ + "static/media/cc_icon-shazam.d427783d.svg";